import React from "react";
import shortid from "shortid";
import useStyles from "@hooks/useStyles";

import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import ButtonBase from "@material-ui/core/ButtonBase";
import Box from "@material-ui/core/Box";

import Avatar from "@material-ui/core/Avatar";
import LineBreak from "@components/Global/Custom/Icons/LineBreak";

const WebsiteMediaColumns = () => {
	const classes = useStyles("Website");

	const backgroundColor = ""; // #ffebe5
	const backgroundGradient = ``; // for testing  linear-gradient(121.04deg,#79dfff 15.69%,#865cff)
	const backgroundImage = ``; // for testing https://wallpapercave.com/wp/wp8377155.jpg
	const coloredBox = false;

	const width = "1200";
	const widthMobile = "420";

	const columns = "3"; // 1-4
	const columnsMobile = "1"; //hardcoded

	const height = width / columns;
	const heightMobile = "180"; //hardcoded

	const headerOverlay = true;

	const header = `Featured categories`;
	const subHeader = `Our latest collections are full of items you will love`;
	const tagline = "";
	const textAlign = "center"; // left / center / right
	const lineBreak = false;
	const content = "";

	const button = "View all";
	const buttonLink = "/wesbite/about-us";

	const buttonSecondary = "Secondary";
	const buttonSecondaryLink = "/wesbite/about-us";

	const video = false;
	const showPrice = true;
	const buttons = true;
	const buttonsLabel = "Book now";

	const cards2 = [
		{
			youtubeEmbedUrl: "https://www.youtube.com/embed/L3gOf2XDp8Y",
			image:
				"https://static.wixstatic.com/media/cde42c_ea87d880b3154a1f943ad5f5635322b4~mv2.jpg/v1/fill/w_756,h_192,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/procaresolutions-logo-2169961.jpg",
		},
		{
			youtubeEmbedUrl: "https://www.youtube.com/embed/L3gOf2XDp8Y",
			image:
				"https://static.wixstatic.com/media/cde42c_e91ced39ec9142fe9f997b014ca9451a~mv2.png/v1/fill/w_908,h_282,al_c,lg_1,q_85,enc_auto/ELEA-copy.png",
		},
		{
			youtubeEmbedUrl: "https://www.youtube.com/embed/L3gOf2XDp8Y",
			image:
				"https://static.wixstatic.com/media/cde42c_ea87d880b3154a1f943ad5f5635322b4~mv2.jpg/v1/fill/w_756,h_192,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/procaresolutions-logo-2169961.jpg",
		},
		{
			youtubeEmbedUrl: "https://www.youtube.com/embed/L3gOf2XDp8Y",
			image:
				"https://static.wixstatic.com/media/cde42c_0461bb464c1a4f90b9424a7cd00dc5f4~mv2.png/v1/fill/w_646,h_282,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/Texas%20Rising%20Star.png",
		},
	];

	const cards = [
		{
			youtubeEmbedUrl: `https://www.youtube.com/embed/L3gOf2XDp8Y`,
			image:
				"https://kidsrkids.com/north-austin/wp-content/uploads/sites/2/2018/10/Childcare_infant_Developmental-600x765.jpg",
			header: "Infant Program",

			description:
				"Ensure your infant gets the tender care and attention they need while you're away at work by enrolling them in our infant care program. Call us for details. Ensure your infaur infant care program. Call us for details.",
			buttonText: "View",
			buttonLink: "/",
		},
		{
			youtubeEmbedUrl: `https://www.youtube.com/embed/L3gOf2XDp8Y`,
			image:
				"https://kidsrkids.com/north-austin/wp-content/uploads/sites/2/2018/10/Daycare_Toddler_Social-600x765.jpg",
			header: "Toddler Program",

			description:
				"Give your toddler an early head start with our toddler care programs. Our teachers make sure that your child learns while having fun in a safe environment.",
			buttonText: "View",
			buttonLink: "/",
		},
		{
			youtubeEmbedUrl: `https://www.youtube.com/embed/L3gOf2XDp8Y`,
			image:
				"https://kidsrkids.com/north-austin/wp-content/uploads/sites/2/2018/10/School_Age_Friends_boys-600x765.jpg",
			header: "Preschool Program",

			description:
				"If your child is between 3 and 5 enroll them in our Pre-K program. Children will start to learn to write, recognize their name, and learn their ABC’s.",
			buttonText: "View",
			buttonLink: "/",
		},
	];

	return (
		<React.Fragment>
			<section
				className={
					tagline || header || subHeader || lineBreak || content
						? "websiteComponent"
						: "websiteComponent thin"
				}
				style={{
					backgroundColor:
						!coloredBox && backgroundColor ? backgroundColor : "unset",
					backgroundImage:
						!coloredBox && backgroundGradient ? backgroundGradient : "unset",
				}}
			>
				{backgroundImage && (
					<Box
						position={"absolute"}
						top={0}
						bottom={0}
						width={"100%"}
						style={{
							backgroundImage: `url(${backgroundImage})`,
							backgroundRepeat: "no-repeat",
							backgroundSize: "cover",
							backgroundPosition: "50% 50%",
							opacity: "0.4",
							//filter: "blur(2px)",
						}}
						zIndex={1}
					/>
				)}

				<Container maxWidth={"lg"} disableGutters style={{ zIndex: 3 }}>
					<div
						className={coloredBox ? classes.featuredTextBox : undefined}
						style={{
							backgroundColor:
								coloredBox && backgroundColor ? backgroundColor : "",
							backgroundImage:
								coloredBox && backgroundGradient ? backgroundGradient : "unset",
						}}
					>
						<Grid
							container
							spacing={10}
							justifyContent="center"
							alignItems={textAlign}
						>
							{(tagline ||
								header ||
								subHeader ||
								lineBreak ||
								content ||
								button ||
								buttonSecondary) && (
								<Grid item xs={12}>
									<Box
										display={"flex"}
										flexDirection={"column"}
										justifyContent={"center"}
										alignItems={textAlign}
										height={"100%"}
									>
										{tagline && (
											<Box className="tagline" textAlign={textAlign}>
												{tagline}
											</Box>
										)}

										{header && (
											<Box component={"h2"} textAlign={textAlign}>
												{header}
											</Box>
										)}

										{subHeader && (
											<Box component={"h3"} textAlign={textAlign}>
												{subHeader}
											</Box>
										)}

										{lineBreak && (
											<Box my={1} textAlign={textAlign}>
												<LineBreak className={classes.lineBreak} />
											</Box>
										)}

										{content && (
											<>
												<Box component={"p"} textAlign={textAlign}>
													{content}
												</Box>
											</>
										)}

										{(button || buttonSecondary) && (
											<Box
												className={classes.columnButtonsBox}
												textAlign={textAlign}
												justifyContent={textAlign}
											>
												{button && (
													<Button
														size="large"
														color="primary"
														variant="contained"
														disableElevation
														href={buttonLink}
														className="columnButton"
													>
														{button}
													</Button>
												)}

												{buttonSecondary && (
													<Button
														size="large"
														color="secondary"
														variant="outlined"
														disableElevation
														href={buttonSecondaryLink}
														className="columnButton"
													>
														{buttonSecondary}
													</Button>
												)}
											</Box>
										)}
									</Box>
								</Grid>
							)}

							<Grid item xs={12}>
								<Grid
									container
									spacing={8}
									//justifyContent="center"
									//alignItems={"center"}
								>
									{cards.map((card) => (
										<Grid
											item
											xs={columnsMobile === "1" ? 12 : 6}
											md={
												columns === "1"
													? 12
													: columns === "2"
													? 6
													: columns === "3"
													? 4
													: 3
											}
											key={shortid.generate()}
										>
											<ButtonBase
												className={classes.columnMediaBox}
												href={card.buttonLink}
											>
												{video ? (
													<>
														<div
															className="video-responsive"
															style={{
																position: "relative",
																paddingBottom: "56.25%",
																height: 0,
															}}
														>
															<iframe
																style={{
																	position: "absolute",
																	top: 0,
																	left: 0,
																	width: "100%",
																	height: "100%",
																}}
																src={card.youtubeEmbedUrl}
																frameBorder="0"
																allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
																allowFullScreen
																title="Embedded YouTube Video"
															/>
														</div>
													</>
												) : (
													<>
														<Box
															width={"100%"}
															height={"100%"}
															display={"flex"}
															position={"relative"}
														>
															<Avatar
																variant="rounded"
																src={card.image}
																alt="pic"
																imgProps={{
																	decoding: "async",
																	loading: "lazy",
																}}
																className={
																	headerOverlay
																		? "pictureMediaCard pictureMediaCardOverlay"
																		: "pictureMediaCard"
																}
															/>

															{headerOverlay && (
																<Box
																	position={"absolute"}
																	bottom={24}
																	right={textAlign === "center" ? 0 : 20}
																	left={textAlign === "center" ? 0 : 20}
																	width={"100%"}
																	zIndex={1}
																>
																	<Box
																		textAlign={textAlign}
																		display={"flex"}
																		justifyContent={textAlign}
																		width={"100%"}
																		flexDirection={"column"}
																	>
																		<Box
																			fontWeight={600}
																			fontSize={24}
																			color={"#FFF"}
																		>
																			{card.header}
																		</Box>
																		{showPrice && (
																			<Box
																				mt={2}
																				fontWeight={600}
																				color={"#FFF"}
																			>
																				From $60.00
																			</Box>
																		)}
																		{buttons && (
																			<Box mt={4}>
																				<Button
																					color="primary"
																					variant="contained"
																					disableElevation
																					className="columnButtonMax"
																				>
																					{buttonsLabel}
																				</Button>
																			</Box>
																		)}
																	</Box>
																</Box>
															)}
														</Box>

														{!headerOverlay && (
															<Box
																my={4}
																textAlign={textAlign}
																display={"flex"}
																justifyContent={textAlign}
																width={"100%"}
																flexDirection={"column"}
															>
																<Box fontWeight={600} fontSize={22}>
																	{card.header}
																</Box>
																{showPrice && (
																	<Box mt={2} fontWeight={600}>
																		From $60.00
																	</Box>
																)}
																{buttons && (
																	<Box mt={4}>
																		<Button
																			color="primary"
																			variant="contained"
																			disableElevation
																			className="columnButtonMax"
																		>
																			{buttonsLabel}
																		</Button>
																	</Box>
																)}
															</Box>
														)}
													</>
												)}
											</ButtonBase>
										</Grid>
									))}
								</Grid>
							</Grid>

							{/* <Grid item xs={12}>
								<Box
									className={classes.columnButtonsBox}
									textAlign={textAlign}
									justifyContent={textAlign}
									mt={"40px !important"}
								>
									{button && (
										<Button
											size="large"
											color="primary"
											variant="contained"
											disableElevation
											href={buttonLink}
											className="columnButton"
										>
											{button}
										</Button>
									)}

									{buttonSecondary && (
										<Button
											size="large"
											color="secondary"
											variant="outlined"
											disableElevation
											href={buttonSecondaryLink}
											className="columnButton"
										>
											{buttonSecondary}
										</Button>
									)}
								</Box>
							</Grid> */}
						</Grid>
					</div>
				</Container>
			</section>
		</React.Fragment>
	);
};

export default WebsiteMediaColumns;
